// extracted by mini-css-extract-plugin
export var btn = "bb_mB J_t1 J_tZ d_bz d_bP d_bD d_dw";
export var full = "bb_yl d_w d_H";
export var hoverStyle = "bb_mF";
export var zoom = "bb_mG";